import { create } from 'zustand';
import type { AnalysisFocus } from '../components/research-lab/run-selector/types';

interface SimTrade {
  totalProfit: number;
  portfolioBeforeTrade?: number;
  maePercent?: number;  // Maximum Adverse Excursion as % of entry price
}

interface FocusState {
  activeFocus: AnalysisFocus | null;
  simTrades: SimTrade[];
  isAnalysisMode: boolean;
  setFocus: (focus: AnalysisFocus) => void;
  clearFocus: () => void;
  setSimTrades: (trades: SimTrade[]) => void;
  setAnalysisMode: (active: boolean) => void;
  reset: () => void;
}

export const useFocusStore = create<FocusState>((set) => ({
  activeFocus: null,
  simTrades: [],
  isAnalysisMode: false,
  setFocus: (focus) => set({ activeFocus: focus }),
  clearFocus: () => set({ activeFocus: null }),
  setSimTrades: (trades) => set({ simTrades: trades }),
  setAnalysisMode: (active) => set({ isAnalysisMode: active }),
  reset: () => set({ activeFocus: null, simTrades: [], isAnalysisMode: false }),
}));
